const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    self: {},
    selfPending: false,
    selfUpdatePendings: [],
    selfError: null,
  },
  mutations: {
    setSelf (state, value) {
      state.self = value
    },
    setSelfPending (state, value) {
      state.selfPending = value
    },
    addSelfUpdatePending (state, value) {
      state.selfUpdatePendings.push(value)
    },
    updateSelf (state, value) {
      state.self = {...state.self, ...value}
    },
    removeSelfUpdatePending (state, value) {
      state.selfUpdatePendings = state.selfUpdatePendings.filter(function (val) {
        return val !== value;
      });
    },
    setSelfError (state, value) {
      state.selfError = value
    },
  },
  actions: {
    getSelf ({ commit }, selfId) {
      commit('setSelfPending', true)
      fb.db.collection("users").doc(selfId).get().then((doc) => {
        if (doc.exists) {
          commit('setSelf', { id: doc.id,...doc.data() })
          commit('setSelfPending', false)
        } else {
          commit('setSelfPending', false)
          return console.log("No such document!");
        }
      }).catch((error) => {
        commit('setSelfError', error)
        commit('setSelfPending', false)
      });
    },
    async updateSelf ({ commit, state }, payload) {
      commit(`addSelfUpdatePending`, payload.field)
      let update = {}
      update[payload.field] = payload.value
      commit("updateSelf", update)
      await fb.db
        .collection("users")
        .doc(fb.firebase.auth().currentUser.uid)
        .update(update).then(()=>{
          commit('setSelfPending', false)
          commit(`removeSelfUpdatePending`, payload.field)
        }).catch((error) => {
          commit('setSelfError', error)
          commit('setSelfPending', false)
          commit(`removeSelfUpdatePending`, payload.field)
        });
      return "next"
      
    },
    uploadProfilePicture({ dispatch }, image) {
      var uploadTask = fb.firebase
        .storage()
        .ref("/profilePictures")
        .child(fb.firebase.auth().currentUser.uid + fb.firebase.firestore.Timestamp.now())
        .putString(image, "data_url");
      uploadTask.on(
        "state_changed",
        function(snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case fb.firebase.storage.TaskState.PAUSED: // or 'paused'
              // console.log("Upload is paused");
              break;
            case fb.firebase.storage.TaskState.RUNNING: // or 'running'
              // console.log("Upload is running");
              break;
          }
        },
        function(error) {
          // Handle unsuccessful uploads
        },
        function() {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            dispatch("updateSelf", { field: "profilePictureUrl", value: downloadURL })
          });
        }
      );
    },
  }
}
  